import { render, staticRenderFns } from "./VerDetalle.vue?vue&type=template&id=61124475&"
import script from "./VerDetalle.vue?vue&type=script&lang=ts&"
export * from "./VerDetalle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('61124475', component.options)
    } else {
      api.reload('61124475', component.options)
    }
    module.hot.accept("./VerDetalle.vue?vue&type=template&id=61124475&", function () {
      api.rerender('61124475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ControlBajaCliente/VerDetalle/VerDetalle.vue"
export default component.exports